import { fetchWithRetry } from "../client";
import { PersonalEjecutivo } from "./types/organizacion";
import { cmsLang, type Locale } from "@/i18n/config";

const matchCode = (code: string) => (item: PersonalEjecutivo) =>
  item.rol?.codigo?.trim().toUpperCase() === code;

export async function fetchOrganizacion(lang: Locale): Promise<{
  gerente: PersonalEjecutivo[];
  vicepresidencias: PersonalEjecutivo[];
  gerencias: PersonalEjecutivo[];
}> {
  const res = await fetchWithRetry<{ data: PersonalEjecutivo[] }>(
    `/organizaciones?lang=${cmsLang(lang)}`,
  );

  const gerente = res.data.filter(matchCode("GG"));
  const vicepresidencias = res.data.filter(matchCode("VP"));
  const gerencias = res.data.filter(matchCode("GER"));

  return { gerente, vicepresidencias, gerencias };
}
